import { TearsheetV2Layout } from '../types';

export const defaultLayout: TearsheetV2Layout = {
  root: {
    id: 'root',
    type: 'box',
    direction: 'column',
    children: [
      {
        id: 'header',
        type: 'panel',
        panelType: 'header',
      },
      {
        id: 'body',
        type: 'box',
        direction: 'row',
        children: [
          {
            id: 'left-col',
            type: 'box',
            direction: 'column',
            children: [
              {
                id: 'company-summary',
                type: 'panel',
                panelType: 'companySummary',
              },
              {
                id: 'investment-thesis',
                type: 'panel',
                panelType: 'investmentThesis',
              },
              {
                id: 'performance-commentary',
                type: 'panel',
                panelType: 'performanceCommentary',
              },
            ],
            sizes: [33.33, 33.33, 33.34],
          },
          {
            id: 'right-col',
            type: 'box',
            direction: 'column',
            children: [
              {
                id: 'company-description',
                type: 'panel',
                panelType: 'companyDescription',
              },
              {
                id: 'investment-summary',
                type: 'panel',
                panelType: 'investmentSummary',
              },
              {
                id: 'performance-summary-grid',
                type: 'panel',
                panelType: 'performanceSummary',
              },
              {
                id: 'capitalization-summary',
                type: 'panel',
                panelType: 'capitalizationSummary',
              },
              {
                id: 'financing-history',
                type: 'panel',
                panelType: 'financingHistory',
              },
            ],
            sizes: [20, 20, 20, 20, 20],
          },
        ],
        sizes: [50, 50],
      },
    ],
    sizes: [10, 90],
  },
  version: 1,
};
